// src/analytics/ga.js

function isLikelyBot() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /bot|spider|crawl|headless/i.test(ua);
}

function gaDebugEnabled() {
  const viteDev = typeof import.meta !== "undefined" && import.meta.env?.DEV;
  const env = typeof import.meta !== "undefined" ? import.meta.env?.VITE_GA_DEBUG : undefined;

  if (env === "0" || env === "false") return false;
  if (env === "1" || env === "true") return true;

  return Boolean(viteDev);
}

function debugLog(type, payload) {
  if (!gaDebugEnabled()) return;

  console.log("[GA DEBUG]", type, payload);
}

export function gaIsEnabled() {
  if (typeof window === "undefined") return false;
  if (window.__DISABLE_GA__ === true) return false;
  if (isLikelyBot()) return false;
  return typeof window.gtag === "function";
}

export function trackPageView(path) {
   const payload = {
    page_path: path,
    page_location: typeof window !== "undefined" ? window.location.href : undefined,
    page_title: typeof document !== "undefined" ? document.title : undefined,
  };

  if (!gaIsEnabled()) {
    debugLog("page_view", payload);
    return;
  }

  window.gtag("event", "page_view", payload);
}

export function trackEvent(name, params = {}) {
  if (!gaIsEnabled()) {
    debugLog(name, params);
    return;
  }
  window.gtag("event", name, params);
}

export function trackRegisterStarted({ method } = {}) {
  trackEvent("register_started", {
    method: method ?? "email",
  });
}

export function trackRegisterCompleted({ method } = {}) {
  trackEvent("register_completed", {
    method: method ?? "email",
  });
}

export function trackCompanyClaimStarted({ company_id, company_slug } = {}) {
  trackEvent("company_claim_started", {
    company_id: company_id ?? undefined,
    company_slug: company_slug ?? undefined,
  });
}

export function trackCompanyClaimCompleted({ company_id, company_slug } = {}) {
  trackEvent("company_claim_completed", {
    company_id: company_id ?? undefined,
    company_slug: company_slug ?? undefined,
  });
}

export function trackCompanyView({ company_id, company_slug, ticker }) {
  trackEvent("company_view", {
    company_id: company_id ?? undefined,
    company_slug: company_slug ?? undefined,
    ticker: ticker ?? undefined,
  });
}

export function trackDirectorySearch({
  query,
  filters_count,
  sort,
  country,
  lifecycle,
  claimed,
  commodities,
  view,
} = {}) {
  trackEvent("directory_search", {
    query_length: query ? String(query).length : 0,
    has_query: Boolean(query),
    filters_count: Number.isFinite(filters_count) ? filters_count : 0,
    sort: sort ?? undefined,
    country: country ?? undefined,
    lifecycle: lifecycle ?? undefined,
    claimed: claimed ?? undefined,
    commodities_count: Array.isArray(commodities) ? commodities.length : 0,
    commodities: Array.isArray(commodities) ? commodities.join(",") : undefined,
    view: view ?? undefined,
  });
}

export function trackResultClicked({ result_type, result_id, result_slug, position, query }) {
  trackEvent("result_clicked", {
    result_type: result_type ?? undefined,
    result_id: result_id ?? undefined,
    result_slug: result_slug ?? undefined,
    position: Number.isFinite(position) ? position : undefined,
    query_length: query ? String(query).length : 0,
  });
}
